export const isSlackPrompt = (prompt) => 'slackUserId' in prompt;
export var AiChatAgents;
(function (AiChatAgents) {
    AiChatAgents["HUMAN"] = "human";
    AiChatAgents["AI"] = "ai";
})(AiChatAgents || (AiChatAgents = {}));
export const isAiConversationMessageComplete = (message) => 'response' in message && 'respondedAt' in message;
//# sourceMappingURL=types.js.map